import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveCourseDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.course.remove ;
}

RemoveCourseDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.courses.url,
    useUrl : true
};

RemoveCourseDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveCourseDialog );
